import payroll from '../views/payroll/index.vue'
import payroll_create from '../views/payroll/create.vue'
import payroll_edit from '../views/payroll/edit.vue'
import payroll_slip from '../views/payroll/slip.vue'
import payroll_import from '../views/payroll/import.vue'

const routes = [
  {
    path: "/payroll",
    name: "payroll",
    component: payroll,
    meta: { authOnly: true },
  },
  {
    path: "/payroll/create",
    name: "payroll_create",
    component: payroll_create,
    meta: { authOnly: true },
  },
  {
    path: "/payroll/edit/:periode/:uuid",
    name: "payroll_edit",
    component: payroll_edit,
    meta: { authOnly: true },
  },
  {
    path: "/payroll/slip/:periode/:uuid",
    name: "payroll_slip",
    component: payroll_slip,
    meta: { authOnly: true },
  },
  {
    path: "/payroll/import",
    name: "payroll_import",
    component: payroll_import,
    meta: { authOnly: true },
  },]

export default routes
